/**
 * Created by rhinov20e on 8/26/2016.
 *
 * Display a picture to notify an object/entity can be rotated by the user
 */

import { math } from "@rhinov/savane-js";


declare var cc: any;

export class RotationNode extends cc.DrawNode {
    constructor(entity: any) {
        // Call parent constructor
        super();

        // Save the object savane entity
        this.entity = entity;

        // Here is the center position
        var center = new cc.p(0, 0);

        // Draw the rotation circle
        this.addRotationCircle(center, undefined);

        // And add 2 arrow sprites on top of it and add them to the renderer
        var arrowSprite = new cc.Sprite();
        arrowSprite.initWithSpriteFrameName('plan/arrowPointYellow.png');
        arrowSprite.setScale(0.25, 0.25);
        arrowSprite.setPosition(this._currentRadius + center.x, center.y);
        arrowSprite.setName('arrow');
        this.addChild(arrowSprite);

        arrowSprite = new cc.Sprite();
        arrowSprite.initWithSpriteFrameName('plan/arrowPointYellow.png');
        arrowSprite.setScale(0.25, 0.25);
        arrowSprite.setPosition(-this._currentRadius + center.x, center.y);
        arrowSprite.setFlippedY(true);
        arrowSprite.setName('arrow1');
        this.addChild(arrowSprite);

        // Set the name of this node
        this.setName('rotateButton');

        // Finally set position, anchor, rotation and visibility
        this.setAnchorPoint(new cc.p(0.5, 0.5));
        this.setPosition(cc.p(0, 0));
        this.setRotation(-this.entity.angle * 180.0 / Math.PI);
        this.setVisible(false);
    }

    // Add the rotation circle to the node to show the entity node (instanciating this node) can be rotated
    addRotationCircle(center: any, color: any) {
        // Compute object size (SavaneJS size but / 10)
        var cocosLength = this.entity.width / 10;
        var realLength = this.entity.realWidth;
        if (realLength !== undefined) {
            cocosLength = realLength / 10;
        }
        var cocosWidth = this.entity.length / 10;
        var realWidth = this.entity.realLength;
        if (realWidth !== undefined) {
            cocosWidth = realWidth / 10;
        }
        // Compute the radius of the bounding circle (plus a bit of margin 10 units)
        var radius = Math.sqrt(cocosWidth * cocosWidth + cocosLength * cocosLength) / 2 + 10;
        // Store the current radius
        this._currentRadius = radius;

        // Draw the rotation circle
        this.drawCircle(center, radius, Math.PI * 2, 100, false, 3, color);
    }

    // Update node, prepare for next frame
    update() {
        // Here is the center position
        var center = new cc.p(0, 0);

        var color = new cc.color('#fbe800');
        if (this.entity.locked) {
            color = new cc.color(255, 125, 141, 255);
        }

        // CLear current node
        this.clear();
        // Draw the rotation circle
        this.addRotationCircle(center, color);

        // Adjust positions of the arrow sprites
        var arrowSprite = this.getChildByName('arrow');
        arrowSprite.setPosition(this._currentRadius + center.x, center.y);
        arrowSprite.setColor(color);

        arrowSprite = this.getChildByName('arrow1');
        arrowSprite.setPosition(-this._currentRadius + center.x, center.y);
        arrowSprite.setColor(color);

        // Set node visibility
        this.setVisible(this.isVisible());
    }

    // Return true of false depending on weither the position passed allows to rotate the object
    toRotate(position: math.vec3) {
        // Necessary only if the node is visible
        if (this.isVisible()) {
            // Compute object size (SavaneJS size but / 10)
            var cocosWith = (this.entity.position[0] - position[0]) / 10;
            var cocosLength = (this.entity.position[1] - position[1]) / 10;

            // Min and max radius where the position will allow to rotate the object
            var radiusMax = this._currentRadius + 10;
            var radiusMin = this._currentRadius - 5;
            // Compute distance from entity to the cursor position passed
            var localtionDis = Math.sqrt(cocosWith * cocosWith + cocosLength * cocosLength);

            // Return if touch is inside the min and max values that allow rotation
            return ((localtionDis >= radiusMin) && (localtionDis <= radiusMax));
        }
        return false;
    }
}
